import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteService } from 'src/app/service/quote.service';

@Component({
  selector: 'app-quote-step8-desktop',
  templateUrl: './quote-step8-desktop.component.html',
  styleUrls: ['./quote-step8-desktop.component.css']
})
export class QuoteStep8DesktopComponent implements OnInit {
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/0ffa27a0-cde7-40b2-b686-1c5fe568d7e8?org_if_sml=1743&force_format=original'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/0c50e848-44cb-4b7a-a43b-7845858dfd22?org_if_sml=1744&force_format=original'
  @Input()
  vectoralt4: string = 'VectorI3390'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f26ba2d0-4228-4104-b97d-26e0b64b668b?org_if_sml=1222&force_format=original'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/9bf8c5b5-a0a4-478a-95ec-4a908208265f?org_if_sml=1740&force_format=original'
  @Input()
  vectorsrc2: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/ff27dda0-1632-42ac-a293-ff7dce3f865e?org_if_sml=1171&force_format=original'
  @Input()
  vectoralt3: string = 'VectorI3390'
  @Input()
  vectoralt1: string = 'VectorI3390'
  @Input()
  vectoralt10: string = 'VectorI3390'
  @Input()
  vectorsrc1: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/bcbc2ead-66cc-4a47-a6d2-eeb21fa63444?org_if_sml=1624&force_format=original'
  @Input()
  rectangle1269alt: string = 'Rectangle12693390'
  @Input()
  gradient21src: string = '/assets/external/gradient213390-j4tc-300w.png'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f26ba2d0-4228-4104-b97d-26e0b64b668b?org_if_sml=1490&force_format=original'
  @Input()
  gradient21alt: string = 'gradient213390'
  @Input()
  vectorsrc: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/f26ba2d0-4228-4104-b97d-26e0b64b668b?org_if_sml=1490&force_format=original'
  @Input()
  vectoralt6: string = 'VectorI3390'
  @Input()
  vectoralt: string = 'VectorI3390'
  @Input()
  rootClassName: string = ''
  @Input()
  rectangle1269src: string = '/assets/external/mobile/rectangle12693390-d9n-2000w.png'
  @Input()
  vectoralt8: string = 'VectorI3390'
  @Input()
  vectorsrc4: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/dbb52b8e-9845-43fb-b175-ea9463a41b1d?org_if_sml=1633&force_format=original'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/24be63e2-58fe-443b-8e86-b430b7f129cd?org_if_sml=1517&force_format=original'
  @Input()
  vectorsrc3: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/4cba59ae-4440-4492-9e73-f5310468b99c?org_if_sml=1503&force_format=original'
  @Input()
  vectoralt9: string = 'VectorI3390'
  @Input()
  vectoralt5: string = 'VectorI3390'
  @Input()
  vectoralt2: string = 'VectorI3390'
  @Input()
  vectoralt7: string = 'VectorI3390'
  raw8w4c: string = ' '

  @Input() screenWidth: number;
  @Input() currentStep: number;
  // @Input() quote: QuoteService.quoteModel; // Add input for quote data
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  isloading = false;
  hasCertificateNumber = false;
  
  // Input setter to watch for quote model changes
  @Input() set quote(value: any) {
    if (value) {
      this.hasCertificateNumber = !!(value && value.certificateNumber);
      if (!this.hasCertificateNumber) {
        console.warn('No certificate number found in updated quote model');
      }
    }
  }
  
  constructor(private quoteService: QuoteService) {}

  nextStep(): void {
    // Check if we have a certificate number before proceeding
    if (!this.hasCertificateNumber) {
      return;
    }

    if (this.quoteService.quoteModel && this.quoteService.quoteModel.certificateNumber) {
      // Show loading modal and set loading state
      this.isloading = true;
      document.getElementById('quoteLoadingModalToggle').click();
      
      // Call getCertificate API first
      this.quoteService.getCertificate$(this.quoteService.quoteModel).subscribe({
        next: (response) => {
          this.quoteService.quoteModel.members[0].memberId = response.members[0].memberId;
          // Hide loading modal
          this.hideLoadingModal();
          // Proceed to next step after successful API call
          this.onNextStep.emit(this.currentStep);
        },
        error: (error) => {
          console.error('Error activating certificate:', error);
          // Hide loading modal on error
          this.hideLoadingModal();
          // You might want to show an error message to the user here
          // For now, we'll still proceed to next step even if there's an error
          this.onNextStep.emit(this.currentStep);
        },
        complete: () => {
          this.isloading = false;
        }
      });
    } else {
      // If no quote or certificate number, proceed directly
      this.onNextStep.emit(this.currentStep);
    }
  }

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }

  /**
   * Hide the loading modal using multiple approaches for maximum compatibility
   */
  private hideLoadingModal(): void {
    const loadingModal = document.getElementById('quoteLoadingModal');
    if (!loadingModal) {
      return;
    }

    // Method 1: Try Bootstrap Modal API
    try {
      const modalInstance = (window as any).bootstrap?.Modal?.getInstance(loadingModal);
      if (modalInstance) {
        modalInstance.hide();
        return;
      }
    } catch (error) {
      console.log('🔍 Bootstrap Modal API failed:', error);
    }

    // Method 2: Try clicking the hidden toggle button (same way it was shown)
    try {
      const toggleButton = document.getElementById('quoteLoadingModalToggle');
      if (toggleButton) {
        toggleButton.click();
        return;
      }
    } catch (error) {
      console.log('🔍 Toggle button method failed:', error);
    }

    // Method 3: Manual DOM manipulation as fallback
    try {
      // Hide the modal
      loadingModal.style.display = 'none';
      loadingModal.classList.remove('show');
      loadingModal.setAttribute('aria-hidden', 'true');
      
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
      // Remove backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      
      // Remove any remaining modal-related classes
      document.body.classList.remove('modal-open');
    } catch (error) {
      console.error('🔍 All modal hiding methods failed:', error);
    }
  }

  ngOnInit() {
    // Check if we have a certificate number
    this.hasCertificateNumber = !!(this.quoteService.quoteModel && this.quoteService.quoteModel.certificateNumber);
    
    if (!this.hasCertificateNumber) {
      console.warn('No certificate number found in quote model');
    }
  }

  /**
   * Manually check and update the certificate number status
   */
  checkCertificateNumberStatus(): void {
    this.hasCertificateNumber = !!(this.quoteService.quoteModel && this.quoteService.quoteModel.certificateNumber);
  }

}
